// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchAboutDataIfNeeded } from '../../../redux/modules/about';
import { recordAnalyticsForAboutUsPageView } from '../../../redux/modules/analytics';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([dispatch(fetchAboutDataIfNeeded())]).then(() => {
        return dispatch(recordAnalyticsForAboutUsPageView());
    });
};
